<h5>2030 Goal: {{linkedOutcomeList.goal.name}}</h5>

<div class="results-grid">
    <div class="results-header">
        <div></div>
        <div>Outcome ID</div>
        <div>2030 Goal Metric</div>
        <div>Linked Progress</div>
        <div>Hub Record ID</div>
        <div>Hub Record Name</div>
    </div>

    @for(linkedOutcome of linkedOutcomeList.linkedOutcomes; track linkedOutcome.projectOutcomeId) {
    <div class="result-row">
        <div class="all-other-fields">
            <div>
                <a class="action-link" href="javascript:void(0)" (click)="removeLink(linkedOutcome)"
                    matTooltip="Unlink Outcome" matTooltipShowDelay="500" matTooltipHideDelay="300">
                    <img src="assets/images/icons/unlink_icon.png">
                    <div class="action-label">UNLINK</div>
                </a>
            </div>
            <div>
                {{linkedOutcome.projectOutcome.outcome.uniqueId}}
            </div>
            <div>
                {{linkedOutcome.projectOutcome.outcome.outcomeMetric.name}}
            </div>
            <div>
                {{linkedOutcome.projectOutcome.outcomeStatistics.totalProgress | number: '1.0-0' }}
                {{linkedOutcome.projectOutcome.outcome.outcomeUnit.name}}
            </div>
            <div>
                {{linkedOutcome.projectOutcome.projectId}}
            </div>
            <div>
                <a href="/portfolio/{{linkedOutcome.projectOutcome.projectId}}" target="_blank">
                    {{linkedOutcome.project.name}}
                </a>
            </div>
        </div>
        <div class="outcome-statement-panel">
            <div class="outcome-statement">
                <strong>Outcome Statement:</strong>
                {{linkedOutcome.projectOutcome.statement}}
            </div>
        </div>

    </div>
    }
</div>
